export default {"src":"/_next/static/media/favicon.d2d69cf9.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};